/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ComplainType {
	None = 0,
	CutqualityLow = 1,
	Scratches = 2,
	MissingCuts = 3,
	WrongBending = 4,
	OutOfTolerance = 5,
	TransportDamage = 6,
	Missing = 7,
	Other = 8,
	WrongGrainDirection = 9,
	PowderCoating = 10,
	Weldline = 11,
	Feature = 12,
	ZincCoating = 13,
	WrongOrMissingPressJoin = 14,
}
